"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rn_css_1 = require("rn-css");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_i18n_1 = require("@unboared/base-ui.i18n");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const text_preset_1 = require("./text.preset");
function Text(props) {
    const { children, tx, text, txOptions, style, preset } = props, rest = __rest(props, ["children", "tx", "text", "txOptions", "style", "preset"]);
    const theme = (0, rn_css_1.useTheme)();
    const { translate } = (0, base_ui_i18n_1.useTranslate)();
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const currentTheme = theme || base_ui_theme_themes_1.defaultTheme;
    // const language = useLanguage(state => state.language);
    // figure out which content to use
    const i18nText = tx && translate(tx, txOptions); //translate(tx, txOptions)
    const content = i18nText || text || children;
    const textTheme = (0, text_preset_1.textPresets)(currentTheme, normalize);
    const textStyle = textTheme[preset || 'normal'];
    const textStyles = [textStyle, style];
    return (react_1.default.createElement(react_native_1.Text, Object.assign({}, rest, { style: textStyles }), content));
}
exports.Text = Text;
//# sourceMappingURL=text.js.map